import { render, staticRenderFns } from "./HeadingDisplayLoader.vue?vue&type=template&id=37288f70&scoped=true"
import script from "./HeadingDisplayLoader.vue?vue&type=script&lang=ts"
export * from "./HeadingDisplayLoader.vue?vue&type=script&lang=ts"
import style0 from "./HeadingDisplayLoader.vue?vue&type=style&index=0&id=37288f70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37288f70",
  null
  
)

export default component.exports